module.exports = __webpack_public_path__ + "img/cross.1ccceed1.svg";